import React from "react";
import notfound from "../assets/notfound.webp";

const Notfound = () => {
  return (
    <div>
      <img className=" mx-auto" src={notfound} alt="" />
    </div>
  );
};

export default Notfound;
